import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = 'https://menteconciente.com./cart/43497804824654:1',
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" className={`
        inline-block px-8 py-4 md:px-10 md:py-5
        bg-gradient-to-r from-amber-500 to-amber-600
        text-white font-bold text-lg md:text-xl
        rounded-full shadow-lg shadow-amber-500/30
        transition-all duration-300
        hover:from-amber-600 hover:to-amber-700
        hover:shadow-xl hover:shadow-amber-500/40
        focus:outline-none focus:ring-4 focus:ring-amber-500/50
        ${className}
      `} animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} data-id="element-21">
      {children}
    </motion.a>;
}